export default "__VITE_ASSET__DedVuuId__"